<template>
  <v-form v-model="valid" ref="DialogForm">
    <slotted-dialog :title="$t('servicesystem.common_objects.service_agreement.service_agreement')"
      :externaltrigger="dialogtrigger" :externalCloseTrigger="closetrigger">
      <template v-slot:content>

        <v-card v-if="loading" height="400">
          <CenteredLoading :displayBool="true" :small="true">
          </CenteredLoading>
        </v-card>


        <v-container v-else-if="editObject" class="pt-0">
          <MachineListItem :machine="Machine" disabled class="ml-n5" :showServiceAgreement="false">
          </MachineListItem>

          <QSwitchInput v-model="IsActive" :label="'Aktiv service avtale?'">
          </QSwitchInput>

          <v-row v-if="IsActive" no-gutters>
            <v-col>
              <v-container :key="resettrigger" style="border: 1px solid #d7d7d7;" class="rounded-lg mt-1 pt-2" fluid>
                <!-- width: 320px; -->
                <v-row no-gutters justify="space-between" align="center">
                  <h3 v-text="$t('servicesystem.common_objects.service_agreement.details')" />
                  <v-btn v-if="isModifiedFromCurrentBestDefault" color="tertiary" small outlined @click="clear()">
                    {{ $t('servicesystem.common_objects.commonterms.reset_to_default') }}
                  </v-btn>
                </v-row>

                <h5 v-text="$t('servicesystem.common_objects.service_agreement.workload')" class="mt-2 mb-3" />
                <v-row no-gutters>
                  <v-col>
                    <v-text-field type="number" v-model.number="editObject.HoursOfWorkEachTechnician"
                      :label="$t('servicesystem.common_objects.service_agreement.estimated_time')"
                      prepend-icon="mdi-clock" dense hide-details :rules="[requiredRule]">
                    </v-text-field>
                  </v-col>
                  <v-col class="px-3">
                    <v-text-field type="number" v-model.number="editObject.NumberOfTechnicianRequired"
                      :label="$t('servicesystem.common_objects.service_agreement.number_of_technicians')"
                      prepend-icon="$technician" dense hide-details :rules="[requiredRule]">
                    </v-text-field>
                  </v-col>
                </v-row>

                <h5 v-text="$t('servicesystem.common_objects.service_agreement.repeat_every')" class="my-3" />
                <v-row no-gutters class="mb-3">
                  <v-col>
                    <v-text-field type="number" v-model.number="editObject.ReoccuranceRepeat"
                      :rules="[v => { return v > 0 || 'Must be a higher number than 0.' }, requiredRule]"
                      :label="$t('servicesystem.common_objects.service_agreement.increment')" prepend-icon="mdi-repeat"
                      dense hide-details>
                    </v-text-field>
                  </v-col>
                  <v-col class="pl-3">
                    <v-select v-model="editObject.ReoccuranceHowOften" :items="reoccuranceHowOftenOptions"
                      :item-text="'text'" :item-value="'value'"
                      :label="$t('servicesystem.common_objects.service_agreement.unit')" dense hide-details
                      :rules="[requiredRule]">
                    </v-select>
                  </v-col>
                </v-row>

                <h5 v-text="$t('servicesystem.common_objects.service_agreement.duration')" />
                <v-row no-gutters>
                  <v-col cols="6">
                    <QTextField type="date" v-model="ReocurrencyStartDate" :key="editObject.ServiceFromInstallationDate"
                      :label="editObject.ServiceFromInstallationDate ? $t('servicesystem.common_objects.service_agreement.start_date_from_install') : $t('servicesystem.common_objects.service_agreement.start_date')"
                      :disabled="!!Machine && !!Machine.InstallationDate && editObject.ServiceFromInstallationDate"
                      :externaledit="!editObject.ServiceFromInstallationDate || (!Machine || !Machine.InstallationDate)"
                      :rules="[requiredRule]">
                    </QTextField>
                  </v-col>
                  <v-col cols="6" class="pl-3">
                    <QTextField type="date" v-model="ReocurrencyEndDate" :key="ReocurrencyStartDate"
                      :label="$t('servicesystem.common_objects.service_agreement.end_date')" externaledit
                      :rules="[requiredRule]">
                    </QTextField>
                  </v-col>
                  <v-col cols="12">
                    <v-checkbox v-model="editObject.ServiceFromInstallationDate"
                      :label="$t('servicesystem.common_objects.service_agreement.installationdate_lock_info')" dense
                      hide-details>
                    </v-checkbox>
                  </v-col>
                </v-row>

              </v-container>
            </v-col>
            <!-- 
            <v-col>
              <v-container>
                <h3 v-text="'Output'" />
                <v-list style="border-left: 1px solid grey">
                  <v-list-item dense>
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        Start:
                      </v-list-item-subtitle>
                      <v-list-item-title>
                        {{ ReocurrencyStartDate }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item dense>
                    jobs generated in between
                  </v-list-item>
                  <v-list-item dense>
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        next job:
                      </v-list-item-subtitle>
                      <v-list-item-title>
                        {{ Machine && Machine.ServiceAgreementNextDate }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item dense>
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        End:
                      </v-list-item-subtitle>
                      <v-list-item-title>
                        {{ ReocurrencyEndDate }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-container>
            </v-col>
            -->
          </v-row>
        </v-container>
      </template>

      <template v-slot:buttons>
        <v-btn @click="closetrigger++" color="close" outlined
          v-text="$t('servicesystem.common_objects.commonterms.close')">
        </v-btn>
        <v-btn v-if="!loading" @click="valid ? handleSave() : null" :loading="saveLoading"
          :color="valid ? 'primary' : 'disabled'">
          {{ $t('servicesystem.common_objects.commonterms.save') }}
        </v-btn>
      </template>

    </slotted-dialog>
  </v-form>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import MachineListItem from "@/components/ListItems/MachineListItem.vue";
import CenteredLoading from "@/components/Sections/CenteredLoading.vue";
import QInputRuleMixin from "@/helpers/Mixins/QInputRuleMixin";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";

export default {
  name: "EditServiceAgreementDialog",
  props: {
    externaltrigger: Number,
    machineId: Number,
    agreement: Object,
  },
  components: {
    CenteredLoading,
    SlottedDialog,
    MachineListItem,
  },
  mixins: [clientAPI, QInputRuleMixin],

  data() {
    return {
      dialogtrigger: 0,
      closetrigger: 0,
      IsActive: false,
      editObject: null,
      valid: false,
      loading: false,
      saveLoading: false,
      value: null,
      resettrigger: 1,

      Machine: null,
      InstallationDate: null,
      MachineTypeDefaultAgreementDetails: null,
      MachineAgreementDetails: null,
    };
  },

  mounted() {
    //this.getServiceAgreementView();
  },

  methods: {
    async getServiceAgreementView() {
      this.loading = true;
      var machine;
      await this.getServiceAgreementByMachineId(this.machineId)
        .then((response) => {
          machine = response.Machine;
          this.MachineAgreementDetails = machine?.MachineServiceAgreement;
        })
        .catch(async (e) => {
          if (e.status == 204) {
            await this.getMachineById(this.machineId)
              .then((response) => {
                machine = response;
              })
          }
        });
      this.Machine = machine;
      this.InstallationDate = machine?.InstallationDate ? this.oldFormatDate(machine?.InstallationDate) : null;
      this.MachineTypeDefaultAgreementDetails = machine?.MachineModel?.MachineType?.ServiceAgreement;
      this.loading = false;
      //console.log("InstallationDate", this.InstallationDate);
      //console.log("DefaultAgreementDetails", this.DefaultAgreementDetails);
      //console.log("MachineTypeDefaultAgreementDetails", this.MachineTypeDefaultAgreementDetails);
      //console.log("MachineAgreementDetails", this.MachineAgreementDetails);
    },

    clear() {
      var copyDefault = Object.assign({}, this.bestApplicableDefaultDetials);
      copyDefault.ReocurrencyStartDate = undefined;
      copyDefault.ReocurrencyEndDate = undefined;
      this.editObject = copyDefault;
      this.resettrigger++;
    },

    setDetails() {
      if (this.MachineAgreementDetails) {
        this.editObject = Object.assign({}, this.MachineAgreementDetails);
        this.editObject.ReocurrencyStartDate = this.oldFormatDate(this.editObject.ReocurrencyStartDate);
        this.editObject.ReocurrencyEndDate = this.oldFormatDate(this.editObject.ReocurrencyEndDate);
      }
      else {
        this.editObject = Object.assign({}, this.bestApplicableDefaultDetials);
        this.editObject.ReocurrencyStartDate = undefined;
        this.editObject.ReocurrencyEndDate = undefined;
      }
      this.IsActive = this.Machine?.ServiceAgreement;
    },

    handleSave() {
      this.saveLoading = true;
      const dto = {
        NumberOfTechnicianRequired: this.editObject.NumberOfTechnicianRequired,
        HoursOfWorkEachTechnician: this.editObject.HoursOfWorkEachTechnician,
        ReoccuranceHowOften: this.editObject.ReoccuranceHowOften,
        ReocurrencyStartDate: this.ReocurrencyStartDate,
        ReocurrencyEndDate: this.ReocurrencyEndDate,
        ReoccuranceRepeat: this.editObject.ReoccuranceRepeat,
        ServiceFromInstallationDate: this.editObject.ServiceFromInstallationDate,
      };
      //console.log("dto", dto);
      this.setServiceAgreement(this.Machine.Id, dto, this.IsActive)
        .then((response) => {
          this.$emit("Update", response);
          this.closetrigger++;
        })
        .catch(() => { })
        .finally(() => {
          this.saveLoading = false;
        });
    },

    async parseItem() {
      await this.getServiceAgreementView();
      this.setDetails();
    },
  },

  computed: {
    bestApplicableDefaultDetials() {
      return this.MachineTypeDefaultAgreementDetails ?? this.DefaultAgreementDetails;
    },

    isModifiedFromCurrentBestDefault() {
      var o1 = {
        ReoccuranceRepeat: this.editObject.ReoccuranceRepeat,
        ReoccuranceHowOften: this.editObject.ReoccuranceHowOften,
        //ReocurrencyStartDate: this.editObject.ReocurrencyStartDate,
        //ReocurrencyEndDate: this.editObject.ReocurrencyEndDate,
        ServiceFromInstallationDate: this.editObject.ServiceFromInstallationDate,
        HoursOfWorkEachTechnician: this.editObject.HoursOfWorkEachTechnician,
        NumberOfTechnicianRequired: this.editObject.NumberOfTechnicianRequired,
      };
      var o2 = {
        ReoccuranceRepeat: this.bestApplicableDefaultDetials.ReoccuranceRepeat,
        ReoccuranceHowOften: this.bestApplicableDefaultDetials.ReoccuranceHowOften,
        //ReocurrencyStartDate: this.bestApplicableDefaultDetials.ReocurrencyStartDate,
        //ReocurrencyEndDate: this.bestApplicableDefaultDetials.ReocurrencyEndDate,
        ServiceFromInstallationDate: this.bestApplicableDefaultDetials.ServiceFromInstallationDate,
        HoursOfWorkEachTechnician: this.bestApplicableDefaultDetials.HoursOfWorkEachTechnician,
        NumberOfTechnicianRequired: this.bestApplicableDefaultDetials.NumberOfTechnicianRequired,
      };
      return JSON.stringify(o1) != JSON.stringify(o2);
    },

    reoccuranceHowOftenOptions() {
      var isPlural = this.editObject.ReoccuranceRepeat != 1;
      return [
        { value: 'Month', text: isPlural ? this.$t('servicesystem.common_objects.commonterms.months') : this.$t('servicesystem.common_objects.commonterms.month') },
        { value: 'Year', text: isPlural ? this.$t('servicesystem.common_objects.commonterms.years') : this.$t('servicesystem.common_objects.commonterms.year') },
      ]
    },

    DefaultAgreementDetails() {
      return this.$store.state.GlobalSettings.DefaultServiceAgreementDetails;
    },

    EnforceEmptyDateFields() {
      return this.$store.state.GlobalSettings.ServiceAgreementEnforceEmptyDateFields;
    },

    ReocurrencyStartDate: {
      get() {
        //if locked to installation date use that
        if (this.editObject.ServiceFromInstallationDate) {
          return this.oldFormatDate(this.InstallationDate ?? this.editObject.ReocurrencyStartDate);
        }
        //else if you have altered the start date manually use that
        else if (this.editObject.ReocurrencyStartDate) {
          return this.oldFormatDate(this.editObject.ReocurrencyStartDate);
        }
        //enforce empty date field if setting is set
        else if (this.EnforceEmptyDateFields) {
          return null;
        }
        //else if there allready was a custom agreement for this machine use the date from that
        else if (this.MachineServiceAgreement) {
          return this.oldFormatDate(this.MachineServiceAgreement.ReocurrencyStartDate);
        }
        //else use show todays date
        else {
          return this.oldFormatDate(new Date().toISOString());
        }
      },
      set(val) {
        this.editObject.ReocurrencyStartDate = val;
      }
    },

    ReocurrencyEndDate: {
      get() {
        //if you have altered the end date manually use that
        if (this.editObject.ReocurrencyEndDate) {
          return this.editObject.ReocurrencyEndDate;
        }
        //else if there allready was a custom agreement for this machine use the date from that
        else if (this.MachineServiceAgreement) {
          return this.oldFormatDate(this.MachineServiceAgreement.ReocurrencyEndDate);
        }
        //enforce empty date field if setting is set
        else if (this.EnforceEmptyDateFields) {
          return null;
        }
        //else use show todays date + intended duration
        else {
          var Difference_In_Time = new Date(this.bestApplicableDefaultDetials.ReocurrencyEndDate) - new Date(this.bestApplicableDefaultDetials.ReocurrencyStartDate);
          //console.log('Difference_In_Time', Difference_In_Time);
          var Difference_In_Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));
          //console.log('Difference_In_Days', Difference_In_Days);
          //console.log('Difference_In_Years', Difference_In_Days / 365, this.bestApplicableDefaultDetials.ReocurrencyStartDate, this.bestApplicableDefaultDetials.ReocurrencyEndDate);

          if (this.ReocurrencyStartDate) {
            var finalCalculatedEndDate = new Date(this.ReocurrencyStartDate).addDays(Difference_In_Days);
            return this.oldFormatDate(finalCalculatedEndDate);
          }
          else {
            return null;
          }
        }
      },
      set(val) {
        this.editObject.ReocurrencyEndDate = val;
      }
    },
  },

  watch: {
    externaltrigger: function () {
      //console.log('externaltrigger');
      this.parseItem();
      this.dialogtrigger++;
    },

    storeTrigger: function () {
      //console.log('storeTrigger');
      this.parseItem();
      this.dialogtrigger++;
    },
  },
};
</script>


<style lang='scss' scoped>
::v-deep .v-input--checkbox .v-label {
  font-size: 13px !important;
  margin-left: 4px;
}
</style>